export const CountDown = function () {
  let counterInterval;
  /*-----------------------------INITIALIZE COUNTER------------------------------*/
  const init = function (selector) {
    const countDownElement = document.querySelector(selector);
    const counterObj = {};
    let remainingTime;
    if (countDownElement) {
      counterObj.element = countDownElement; //Set counter element
      counterObj.endDate = counterObj.element.getAttribute("data-date"); //Get end date from element
      counterObj.dayLimit =
        counterObj.element.getAttribute("data-daylimit") || false;

      if (counterObj.dayLimit) {
        counterObj.dayLimit = counterObj.dayLimit * 24 * 60 * 60; //convert to seconds
      }

      //Check if counter element exist and if endDate is set
      if (counterObj.endDate) {
        counterObj.daysEl = counterObj.element.querySelector(".counter-d");
        counterObj.hoursEl = counterObj.element.querySelector(".counter-h");
        counterObj.minutesEl = counterObj.element.querySelector(".counter-m");
        counterObj.secondsEl = counterObj.element.querySelector(".counter-s");
        remainingTime = getRemainingTime(counterObj.endDate);
        remainingTime = (remainingTime.total / 1000).toFixed(0);

        if (
          counterObj.dayLimit === false ||
          (remainingTime <= counterObj.dayLimit && remainingTime > 0)
        ) {
          updateCounter(counterObj);
          counterInterval = setInterval(function () {
            updateCounter(counterObj);
          }, 1000);
          counterObj.element.parentElement.removeAttribute("data-visible");
        }
      }
    }
  };

  /*-----------------------------GET REMAINING TIME ------------------------------*/
  const getRemainingTime = function (endDate) {
    const t = Date.parse(endDate) - Date.parse(new Date());
    const seconds = Math.floor((t / 1000) % 60);
    const minutes = Math.floor((t / 1000 / 60) % 60);
    const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    const days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
      total: t,
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    };
  };

  /*-----------------------------CREATE COUNTER ------------------------------*/
  const updateCounter = function (counterObj) {
    const t = getRemainingTime(counterObj.endDate);
    counterObj.daysEl.innerHTML =
      ("0" + t.days).slice(-2) +
      `${frontendVars.countryCode === "fr" ? "j" : "d"}`;
    counterObj.hoursEl.innerHTML = ("0" + t.hours).slice(-2) + "h";
    counterObj.minutesEl.innerHTML = ("0" + t.minutes).slice(-2) + "m";
    counterObj.secondsEl.innerHTML = ("0" + t.seconds).slice(-2) + "s";
    if (t.total <= 0) {
      clearInterval(counterInterval);
      counterObj.element.parentElement.classList.add("d-none"); //Remove timer element when timer is 0.
    }
  };

  /*-----------------------------Public methods------------------------------*/
  return {
    init: init,
  };
};
